module.exports = __webpack_public_path__ + "img/fon-home.17a995ad.png";